/* eslint-disable max-len */
/* eslint-disable react/jsx-one-expression-per-line */
import Markdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Spacer from '../components/Spacer';
import { createTagNavLink } from '../utils/urlHelpers';

// Metadata for the blog post
export const metadata = {
  id: 'events-in-coachella-valley',
  date: '2025-04-01', // YYYY-MM-DD format
  author: 'Maria Chavez-Brown, M.S.W., L.C.S.W.',
  tags: ['events', 'Coachella Valley'], // Add relevant tags
};

function BlogPost() {
  const { t } = useTranslation();
  const language = localStorage.getItem('i18nextLng') || 'en';
  const markdownFilePath = `/content/${language}/${metadata.date}-${metadata.id}.md`;
  const [markdown, setMarkdown] = useState('');

  useEffect(() => {
    window.fetch(markdownFilePath)
      .then((response) => response.text())
      .then((text) => setMarkdown(text))
      .catch((error) => console.error('Error loading markdown:', error));
  }, [language, markdownFilePath]);

  return (
    <div className="container-xxl">
      <Spacer height={100} />
      <article className="blog-post">
        <header className="mb-4">
          <h1 className="text-primary">{t(`blog.posts.${metadata.id}.title`)}</h1>
          <div className="text-muted mb-2">
            {t('blog.publishedOn')}
            {' '}
            {new Date(metadata.date).toLocaleDateString()}
            {' '}
            |
            {' '}
            {metadata.author}
          </div>
          {metadata.tags.map((tag) => (
            createTagNavLink(tag)
          ))}
        </header>

        <div className="blog-content bg-light p-4 rounded-3">
          <Markdown rehypePlugins={[rehypeRaw]}>{markdown}</Markdown>
        </div>
      </article>
      <Spacer height={50} />
    </div>
  );
}

export default BlogPost;
